/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCsv = createReactComponent("csv", "IconCsv", [
  [
    "path",
    {
      d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1",
      key: "svg-0"
    }
  ],
  ["path", { d: "M17 8l2 8l2 -8", key: "svg-1" }],
  ["path", { d: "M7 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", key: "svg-2" }]
]);

export { IconCsv as default };
//# sourceMappingURL=IconCsv.js.map
